import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";

const Slider = () => {
    const [listData, setListData] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchListData = () => {
        axios.post(API_URL.SLIDER_LIST, {}).then(
            (res) => {
                if (res.data.status === 1) {
                    setListData(res.data.data);
                }
                setLoading(false);
                if (sessionStorage.getItem("pId")) {
                    let rId = "row-" + JSON.parse(sessionStorage.getItem("pId"));
                    setTimeout(() => {
                        scrollToRow(rId);
                    }, 100);
                }
            },
            (error) => {
                setLoading(false);
                toast.error("Something went wrong..", {
                    autoClose: 3000,
                    position: "top-right",
                });
            }
        );
    };

    const deleteSlider = (row) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this - " + row.title,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios.post(API_URL.SLIDER_DELETE, { id: row.id }).then(
                    (res) => {
                        if (res.data.status === 1) {
                            let newData = listData.filter((r) => r.id != row.id);
                            setListData(newData);
                        }
                        toast.success("Delete Successfully", {
                            autoClose: 3000,
                            position: "top-right",
                        });
                        setLoading(false);
                    },
                    (error) => {
                        setLoading(false);
                        toast.error("Something went wrong..", {
                            autoClose: 3000,
                            position: "top-right",
                        });
                    }
                );
            }
        });
    };

    useEffect(() => {
        fetchListData();
    }, []);

    const scrollToRow = (rowId) => {
        const rowElement = document.getElementById(rowId);
        if (rowElement) {
            rowElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <h1>
                        Slider
                        <small className="me-2">({listData.length})</small>
                    </h1>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center  justify-content-end">
                        <Link to={"/slider/add"} className="btn btn-primary">
                            <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
                            Slider
                        </Link>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-body p-0">
                            {loading && <Loader></Loader>}
                            {!loading && (
                                <div className="table-responsive">
                                    <table className="table mb-0">
                                        <thead className="">
                                            <tr>
                                                <th style={{ width: "5%" }}>#</th>
                                                <th style={{ width: "20%" }}>Image</th>
                                                <th style={{ width: "60%" }}>Title</th>
                                                <th style={{ width: "300px" }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listData.map((row, key) => {
                                                return (
                                                    <tr id={"row-" + row.id} key={key}>
                                                        <td>{key + 1}</td>
                                                        <td className="table-avatar"><div
                                                            style={{
                                                                backgroundImage: "url(" + row.image + ")",
                                                                height: 50,
                                                                width: 50,
                                                                backgroundSize: "cover",
                                                                backgroundPosition: "center",
                                                            }}
                                                        ></div></td>
                                                        <td>{row.title}</td>
                                                        <td className="d-flex">
                                                            <Link to={`/slider/edit/${row.id}`} className="btn btn-sm btn-secondary mr-2">
                                                                <i className="fa fa-edit me-1"></i> Edit
                                                            </Link>
                                                            <button onClick={() => deleteSlider(row)} className="btn btn-sm btn-danger">
                                                                <i className="fa fa-trash me-1"></i> Delete
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Slider;
